import { UpiPaymentDetailDto } from "./upi-payment-detail-dto";

export class UpiPayment {

    refNo: string;
    amount: number = 0;
    fromLocationCode: number;
    bankCode: number;
    upiPaymentDetails: UpiPaymentDetailDto[]=[];
}
